import { h, FunctionComponent } from 'preact';
import { addPrefixToUrl } from 'utils/string.utils';

interface LinkProps {
  url?: string;
  type?: string;
  className?: string;
  id?: string;
  ariaLabel?: string;
  ariaLabelledBy?: string;
}

const Link: FunctionComponent<LinkProps> = ({
  url,
  type,
  children,
  className,
  id,
  ariaLabel,
  ariaLabelledBy,
}) => {
  if (!url) {
    return (
      <div className={className} data-testid={id || 'link-content'}>
        {children}
      </div>
    );
  }
  const href = type === 'url' ? addPrefixToUrl(url) : url;
  return (
    <a
      className={className}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={id || 'link-anchor'}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
    >
      {children}
    </a>
  );
};

Link.defaultProps = {
  type: 'url',
};

export default Link;
